import "@/App.css";
import { SmoothScroll } from "./components/SmoothScroll";
import { Hero } from "./components/Hero";
import { Links } from "./components/Links";
import { Marquee } from "./components/Marquee";
import { Catalog } from "./components/Catalog";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { Benefits } from "./components/Benefits";
import { Solutions } from "./components/Solutions";
import { Differentials } from "./components/Differentials";
import { CtaBanner } from "./components/CtaBanner";
import { InstagramFeed } from "./components/InstagramFeed";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App bg-paper text-ink min-h-screen">
      <SmoothScroll />
      <div className="grain fixed inset-0 pointer-events-none z-50 opacity-[0.06]" />
      <main className="mx-auto max-w-[1440px]">
        <Hero />
        <Benefits />
        <Solutions />
      </main>
      <Marquee />
      <main className="mx-auto max-w-[1440px]">
        <Catalog />
        <Differentials />
        <CtaBanner />
        <InstagramFeed />
        <Links />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
